<section
  class="crowdctrl-form-layout"
  [class.crowdctrl-form-layout--standalone]="standalone"
  [class.crowdctrl-form-layout--pad-horizontal]="padHorizontal"
  [class.crowdctrl-form-layout--pad-vertical]="padVertical"
  [attr.aria-labelledby]="headingId || null"
>
  @if (heading) {
    <h2 class="crowdctrl-form-layout__heading" [id]="headingId || null">{{ heading }}</h2>
  }

  @if (description) {
    <p class="crowdctrl-form-layout__description">{{ description }}</p>
  }

  <ng-content select="[crowdctrlFormSummary]"></ng-content>

  @if (errorMessage) {
    <p class="crowdctrl-form-layout__error" role="alert">{{ errorMessage }}</p>
  }

  <ng-content></ng-content>
</section>
